import { Link } from "react-router-dom";
import { TableCell, TableRow } from "./ui/table";
import { HealthBadge } from "./HealthBadge";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Badge } from "./ui/badge";
import { dollars, intFmt, pct } from "@/lib/money";
import { relTime } from "@/lib/time";
import type { CreatorListItem } from "@/lib/types";

export function CreatorRow({ creator: c }: { creator: CreatorListItem }) {
  return (
    <TableRow className="cursor-pointer">
      <TableCell>
        <Link to={`/creators/${c.creator_id}`} className="flex items-center gap-2.5">
          <Avatar className="h-7 w-7">
            <AvatarImage src={c.avatar_url ?? undefined} alt="" />
            <AvatarFallback>{(c.handle ?? "??").slice(0, 2).toUpperCase()}</AvatarFallback>
          </Avatar>
          <div className="leading-tight">
            <div className="text-sm font-medium">@{c.handle}</div>
            <div className="text-2xs text-muted-foreground">{c.display_name}</div>
          </div>
        </Link>
      </TableCell>
      <TableCell>
        <Badge tone={c.status === "active" ? "success" : c.status === "paused" ? "warning" : "danger"}>
          {c.status}
        </Badge>
        {c.approval_mode === "supervised" ? (
          <Badge tone="info" className="ml-1">
            supervised
          </Badge>
        ) : null}
      </TableCell>
      <TableCell className="tnum text-right">{intFmt(c.members_active_7d)}</TableCell>
      <TableCell className="tnum text-right">{intFmt(c.sends_7d)}</TableCell>
      <TableCell className="tnum text-right">{dollars(c.revenue_7d_cents)}</TableCell>
      <TableCell className="tnum text-right">{pct(c.conversion_7d_pct)}</TableCell>
      <TableCell className="text-right text-muted-foreground tnum">
        {relTime(c.last_self_report_at)}
      </TableCell>
      <TableCell>
        <HealthBadge health={c.health} reasons={c.health_reasons} />
      </TableCell>
    </TableRow>
  );
}
